import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { MdDirectionsCar, MdAddLocationAlt } from "react-icons/md";
import { FaRegUser } from "react-icons/fa";
import { STR_REQUEST_RIDE, STR_MY_RIDES, STR_ACCOUNT } from "../Strings";

export default function HomeMenu() {

  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  const tileStyle = {
    background: "var(--surfaceColor)",
    borderRadius: "18px",
    padding: "18px 10px",
    boxShadow: "var(--shadow3)",
    cursor: "pointer",
    transition: "transform 0.15s ease, box-shadow 0.15s ease",
    textAlign: "center"
  };

  const iconWrapperStyle = {
    width: 56,
    height: 56,
    borderRadius: "50%",
    background: "rgba(0,0,0,0.05)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto"
  };

  const titleStyle = {
    fontSize: "13px",
    fontWeight: 600,
    marginTop: "10px",
    lineHeight: "1.2",
    textAlign: "center",
  };

  function Tile({ icon, title, onClick }) {
    return (
      <div className="col-4 mb-4">
        <div
          style={tileStyle}
          onClick={onClick}
          onMouseDown={e => e.currentTarget.style.transform = "scale(0.96)"}
          onMouseUp={e => e.currentTarget.style.transform = "scale(1)"}
        >
          <div style={iconWrapperStyle}>
            {icon}
          </div>
          <div style={titleStyle}>
            {title}
          </div>
        </div>
      </div>
    );
  }

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <div className="row" style={{ marginTop: 30, marginBottom: 20 }}>

      {/* My Rides */}
      <Tile
        icon={<MdDirectionsCar size={30} color="var(--primaryColor)" />}
        title={STR_MY_RIDES[appContext.language]}
        onClick={() => appContext.navTo({ item: 'my_rides' })}
      />

      {/* Request Ride */}
      <Tile
        icon={<MdAddLocationAlt size={30} color="var(--primaryColor)" />}
        title={STR_REQUEST_RIDE[appContext.language]  }
        onClick={() => appContext.navTo({ item: 'request_ride' })}
      />

      {/* My Account */}
      <Tile
        icon={<FaRegUser size={28} color="var(--primaryColor)" />}
        title={STR_ACCOUNT[appContext.language]}
        onClick={() => appContext.navTo({ item: 'account' })}
      />

    </div>
  );
}